import {Service} from "@/apiServices/Service";

export class CuponesService extends Service {
    constructor() {
        super("cupon/");
    }
    obtenerCupones(datos) {
        return this.http.post(this.getUrl(['obtener']), datos)
            .then((response) => this.onData(response))
            .catch(this.onError)
            .finally(() => {
                this.onFinaly();
            })
    }
    obtenerHerramienta(datos) {
        return this.http.post(this.getUrl(['obtenerHerramientaCierre']), datos)
            .then((response) => this.onData(response))
            .catch(this.onError)
            .finally(() => {
                this.onFinaly();
            })
    }

}